import { render } from "./a-footer.vue?vue&type=template&id=15ba6af9&scoped=true"
import script from "./a-footer.vue?vue&type=script&lang=js"
export * from "./a-footer.vue?vue&type=script&lang=js"

import "./a-footer.vue?vue&type=style&index=0&id=15ba6af9&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ba6af9"]])

export default __exports__